// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/cnquery_cnspec_actions.go

export const GET_UPLOAD_URL = "cnspec.policy.PolicyResolver.GetUploadURL";
